import { red, teal, indigo, blueGrey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export function getTheme() {
  return createTheme({
    palette: {
      primary: {
        main: teal[600],
        light: teal[300],
        dark: teal[800],
        contrastText: "#fff",
      },
      secondary: {
        main: indigo[400],
        light: indigo[200],
        dark: indigo[600],
        contrastText: "#fff",
      },
      error: {
        main: red.A400,
      },
      background: {
        default: blueGrey[50],
        paper: "#ffffff",
      },
    },

    shape: {
      borderRadius: 8,
    },

    typography: {
      fontFamily: [
        "Roboto",
        "-apple-system",
        "BlinkMacSystemFont",
        "sans-serif",
      ].join(","),
    },

    components: {
      MuiAppBar: {
        defaultProps: {
          elevation: 4,
          color: "primary",
          position: "static",
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
    },
  });
}
